export default __webpack_public_path__ + "static/media/basic-pin-large-5.790dd84e.png";